import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InputValidIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M13.854 4.146a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L5.5 11.793l7.646-7.647a.5.5 0 0 1 .708 0Z" />
  </IconWrapper>
)

export default InputValidIconSmall
